<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.33301 12V4.66665C2.33301 1.99998 2.99967 1.33331 5.66634 1.33331H10.333C12.9997 1.33331 13.6663 1.99998 13.6663 4.66665V11.3333C13.6663 11.4266 13.6663 11.52 13.6597 11.6133"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.23301 10H13.6663V12.3333C13.6663 13.62 12.6197 14.6667 11.333 14.6667H4.66634C3.37967 14.6667 2.33301 13.62 2.33301 12.3333V11.9C2.33301 10.8533 3.18634 10 4.23301 10Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.33301 4.66669H10.6663"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.33301 7H8.66634"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "history",
};
</script>

<style lang="scss" scoped></style>
